import React from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CheckmarkIcon } from '../../../resources/assets/components/DLS_Checkmark.svg';
import { SubSection } from '../heading/subsection/subsection.js';
function Color(props) {
    const className = classNames({
        'c-theme-selector__color': true,
        'is-selected': props.selected,
        [`${props.prefix}-${props.color}`]: true,
    });
    return (React.createElement("div", { className: className, onClick: props.onClick },
        React.createElement("span", { className: "c-theme-selector__color-name" }, props.color),
        props.selected ? (React.createElement(CheckmarkIcon, { className: "c-theme-selector__icon" })) : null));
}
function ColorBlock(props) {
    if (!props.colors.length) {
        return null;
    }
    const className = classNames({
        [props.className]: true,
    });
    return (React.createElement(SubSection, { className: className, title: props.title },
        React.createElement("div", { className: "c-theme-selector__color-block-content" }, props.colors.map((color) => (React.createElement(Color, { color: color, key: color, onClick: () => props.onClick(color), prefix: props.prefix, selected: props.selected === color }))))));
}
export { Color, ColorBlock, };
//# sourceMappingURL=color-block.js.map